import { render } from "./Signup.vue?vue&type=template&id=046860ce&scoped=true&ts=true"
import script from "./Signup.vue?vue&type=script&lang=ts"
export * from "./Signup.vue?vue&type=script&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=046860ce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046860ce"]])

export default __exports__